module.exports = __webpack_public_path__ + "img/终.64893134.png";